import personal from '@/assets/pink-one/personal.svg';
import functions from '@/assets/pink-one/function.svg';
import setting from '@/assets/pink-one/setting.svg';
import message from '@/assets/pink-one/message.svg';

export const announcements = [
  {
    tag: {
      bgColor: '#3A3A3A',
      txt: '公告',
    },
    content: '贈送清潔打掃',
    notificationNum: '1',
    date: '今天',
  },
  {
    tag: {
      bgColor: '#DD6763',
      txt: '包裹',
    },
    content: '未領取',
    notificationNum: '4',
    date: '今天',
  },
  {
    tag: {
      bgColor: '#E08846',
      txt: '訪客',
    },
    content: '15:00來訪',
    notificationNum: '',

    date: '今天',
  },
  {
    tag: {
      bgColor: '#29619B',
      txt: '瓦斯',
    },
    content: '未抄錶',
    notificationNum: '',

    date: '昨天',
  },
  {
    tag: {
      bgColor: '#95951D',
      txt: '寄物',
    },
    content: '未領取',
    notificationNum: '',

    date: '12/11',
  },
];

export const navbarItems = [
  {
    url: personal,
    alt: 'personal',
    txt: '個人',
  },
  {
    url: functions,
    alt: 'function',
    txt: '功能',
  },
  {
    url: setting,
    alt: 'setting',
    txt: '設定',
  },
  {
    url: message,
    alt: 'message',
    txt: '訊息',
  },
];
